import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const SensorIcon24 = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    d='M13.3297 19.2901C13.3297 20.0025 12.7523 20.5799 12.0398 20.5799C11.3274 20.5799 10.75 20.0025 10.75 19.2901C10.75 18.5777 11.3274 18 12.0398 18C12.7523 18 13.3297 18.5777 13.3297 19.2901Z'
    fill={props.color ?? 'white'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M8.37327 15.8106C7.41622 16.6613 6.75 17.9535 6.75 19.75C6.75 20.1642 6.41421 20.5 6 20.5C5.58579 20.5 5.25 20.1642 5.25 19.75C5.25 17.5465 6.08378 15.8387 7.37673 14.6894C8.65587 13.5524 10.3402 13 12 13C13.6598 13 15.3441 13.5524 16.6233 14.6894C17.9162 15.8387 18.75 17.5465 18.75 19.75C18.75 20.1642 18.4142 20.5 18 20.5C17.5858 20.5 17.25 20.1642 17.25 19.75C17.25 17.9535 16.5838 16.6613 15.6267 15.8106C14.6559 14.9476 13.3402 14.5 12 14.5C10.6598 14.5 9.34413 14.9476 8.37327 15.8106Z'
    fill={props.color ?? 'white'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M15.9697 10.0303C13.7626 7.82322 10.2374 7.82322 8.03033 10.0303C7.73744 10.3232 7.26256 10.3232 6.96967 10.0303C6.67678 9.73745 6.67678 9.26257 6.96967 8.96968C9.76256 6.17677 14.2374 6.17677 17.0303 8.96968C17.3232 9.26257 17.3232 9.73745 17.0303 10.0303C16.7374 10.3232 16.2626 10.3232 15.9697 10.0303Z'
    fill={props.color ?? 'white'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M19.4697 7.90534C15.2626 3.69822 8.73744 3.69823 4.53033 7.90531C4.23743 8.1982 3.76256 8.1982 3.46967 7.9053C3.17678 7.61241 3.17678 7.13754 3.46967 6.84464C8.26256 2.05178 15.7374 2.05178 20.5303 6.84468C20.8232 7.13757 20.8232 7.61245 20.5303 7.90534C20.2374 8.19823 19.7626 8.19823 19.4697 7.90534Z'
    fill={props.color ?? 'white'}
  />
</Svg>;

export default SensorIcon24;
